import { render } from "./ServicesDisplayMobile.vue?vue&type=template&id=d6a21140&scoped=true"
import script from "./ServicesDisplayMobile.vue?vue&type=script&lang=js"
export * from "./ServicesDisplayMobile.vue?vue&type=script&lang=js"

import "./ServicesDisplayMobile.vue?vue&type=style&index=0&id=d6a21140&scoped=true&lang=css"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a21140"]])

export default __exports__